var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"workshop-enroll"},[_c('img',{staticClass:"workshop-enroll-bg",attrs:{"src":_vm.$getImgUrl('/site-images/activity/workshop-enroll/kangzhong-app.png')}}),_c('img',{staticClass:"immediatelyEnroll",attrs:{"src":require("../../assets/images/activity/workshop/immediatelyEnroll.png")},on:{"click":_vm.toEnprll}})])
}
var staticRenderFns = []

export { render, staticRenderFns }